import { useEffect } from 'react';
import {
  useLocation, useNavigate,
} from 'react-router-dom';
import { useIsUserSignedInSelector } from '~/store/userData/userData.selectors';

export const useNavigateAfterLogin = (isEnabled = true) => {
  const navigate = useNavigate();
  const isUserSignedIn = useIsUserSignedInSelector();
  const { state } = useLocation();

  useEffect(() => {
    if (isEnabled && isUserSignedIn) {
      navigate(state?.from ?? '/');
    }
  }, [navigate, isEnabled, isUserSignedIn, state?.from]);
};
